/** @jsx $jsx */
import { $jsx } from 'framework7';
import { usadosFunciones } from "../js/usadosFunciones";
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on;
  var usados = new usadosFunciones();
  var userID = localStorage.getItem('idUser');
  window.saveTarea = function (idVehiculo, idTarea, tipo, valor) {
    usados.saveTarea($f7, idVehiculo, idTarea, tipo, valor);
  };
  window.saveTotalTarea = function (idVehiculo, idGrupoTarea, valor) {
    usados.saveTotalTarea($f7, idVehiculo, idGrupoTarea, valor);
  };
  $on('pageInit', function (event, page) {
    var vehiculoID = page.route.query.id;
    var marcaID = page.route.query.marca;
    var modeloID = page.route.query.modelo;
    var versionID = page.route.query.version;
    var estadoID = page.route.query.idestado;
    var alta = page.route.query.alta;
    // let vendedor = page.route.query.vendedor;
    // let inspector = page.route.query.inspector;

    var vendedorID = page.route.query.vendedor;
    var inspectorID = page.route.query.inspector;
    var colorID = page.route.query.color;
    console.log(page.route.query);
    // console.log(vendedorID);
    // console.log(inspectorID);
    // console.log(colorID);
    $('#id_usuario').val(userID);
    if (vehiculoID) {
      var consultaID = localStorage.getItem('consultaID');
      if (consultaID > 0) {
        $('input').prop('disabled', true);
        $('select').prop('disabled', true);
        $('textarea').prop('disabled', true);
        $('button').prop('disabled', true);
        $('.item-link.smart-select.smart-select-init').attr('data-open-in', '');
      }

      // usados.listarVehiculos($f7, vehiculoID);
      $('#title-page').empty();
      $('#title-page').html('EDITAR VEHICULO');

      // Cargo desplegables
      usados.getMarcas($f7, marcaID);
      usados.getModelos($f7, marcaID, modeloID);
      usados.getVersiones($f7, modeloID, versionID);

      // usados.getUsuarioByPerfil($f7, 4, 'get-vendedores', vendedor);
      // usados.getUsuarioByPerfil($f7, 5, 'get-inspectores', inspector);
      usados.getEstados($f7, estadoID);
      usados.getVendedores($f7, vendedorID);
      usados.getInspectores($f7, inspectorID);
      usados.getColores($f7, colorID);

      // Cargo el resto de la informacion de la unidad cargada
      usados.listarVehiculo($f7, vehiculoID);
      $('#id_vehiculo').val(vehiculoID);

      // Agrego el link correspondiente al link de imagenes
      $('#btn-imagen-color').css('color', '#00b33c');
      $('#btn-href-url').attr("href", '/usadosimagenes/?id_vehiculo=' + vehiculoID);

      // Agrego el link correspondiente al link de peritajes
      $('#btn-imagen-color').css('color', '#00b33c');
      $('#btn-href-url-peritaje').attr("href", '/usadosperitajes/?id_vehiculo=' + vehiculoID);
      $('#alta').val(alta);
    } else {
      usados.getMarcas($f7, 0);
      // usados.getUsuarioByPerfil($f7, 4, 'get-vendedores');
      // usados.getUsuarioByPerfil($f7, 5, 'get-inspectores');
      usados.getEstados($f7, 0);
      usados.getVendedores($f7, 0);
      usados.getInspectores($f7, 0);
      usados.getColores($f7, 0);
      $('#id_vehiculo').val(0);

      // Defino fecha de inicio
      var date = new Date();
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var year = date.getFullYear();
      var currentDate = "".concat(year, "-").concat(month, "-").concat(day);
      $('#alta').val(currentDate);
    }
    $('#get-marcas').on('change', function () {
      var marcaID = $(this).val();
      usados.getModelos($f7, marcaID, 0);
    });
    $('#get-modelos').on('change', function () {
      var modeloID = $(this).val();
      usados.getVersiones($f7, modeloID, 0);
    });
    $('#saveVehiculo').on('click', function () {
      usados.saveVehiculos($f7, 'form-vehiculos');
    });
    $('item-tarea').on('change', function (e) {
      console.log(e);
      usados.saveTarea(idVehiculo, idTarea, tipo, valor);
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="abm">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Volver</span>
          </a>
        </div>
        <div class="title" id="title-page">ALTA VEHICULO</div>
      </div>
    </div>
    <div class="toolbar tabbar tabbar-labels toolbar-bottom">
      <div class="toolbar-inner">
        <a href="#tab-1" class="tab-link" id="saveVehiculo">
          <i class="icon f7-icons if-not-md" style="color: darkslateblue;">floppy_disk</i>
          <i class="icon material-icons md-only">floppy_disk</i>
          <span class="tabbar-label">Guardar</span>
        </a>
        <a href="" class="link" id="btn-href-url-peritaje">
          <i class="icon f7-icons if-not-md" id="btn-imagen-color">text_badge_checkmark</i>
          <i class="icon material-icons md-only">file_upload</i>
          <span class="tabbar-label">Peritaje</span>
        </a>
        <a href="" class="link" id="btn-href-url">
          <i class="icon f7-icons if-not-md" id="btn-imagen-color">cloud_upload_fill</i>
          <i class="icon material-icons md-only">file_upload</i>
          <span class="tabbar-label">Imagenes</span>
        </a>
      </div>
    </div>
    <div class="page-content">
      <form id="form-vehiculos">
        <input type="hidden" id="id_vehiculo" name="id_vehiculo" />
        <input type="hidden" id="id_usuario" name="id_usuario" />
        <div class="block">
          <p class="row text-align-right">
            <a class="" href="#"></a>
            <a class="" href="#"></a>
            <a class="button button-fill button-small color-pink back" href="#">Cancelar</a>
          </p>
          <p class="alert">Todos los campos son obligatorios</p>
          <div class="list">
            <ul>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="date" id="alta" name="alta" placeholder="Fecha alta" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li>
                <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar marca">
                  <select name="marca" id="get-marcas">        
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-marcas-title">Marca</div>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar modelo">
                  <select name="modelo" id="get-modelos">
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-modelos-title">Modelo</div>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <!-- <a class="item-link smart-select smart-select-init" data-open-in="popup" data-virtual-list="true" data-page-back-link-text="Go back"> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar version">
                  <select name="version" id="get-versiones">
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-versiones-title">Version</div>
                    </div>
                  </div>
                </a>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="text" id="patente" name="patente" placeholder="PATENTE" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="number" id="anio" name="anio" placeholder="AÑO" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="number" id="kilometros" name="kilometros" placeholder="KILOMETROS" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <!-- <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="text" id="color" name="color" placeholder="COLOR" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li> -->
              <li>
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="COLOR">
                  <select name="color" id="get-colores">        
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-colores-title">Colores</div>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar estado">
                  <select name="estado" id="get-estados">        
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-estados-title">Estado</div>
                    </div>
                  </div>
                </a>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <input type="number" id="total_gastos" name="total_gastos" placeholder="TOTAL GASTOS" />
                    <span class="input-clear-button"></span>
                  </div>
                </div>
              </li>
              <li>
                <!-- <div class="item-content item-input">
                  <div class="item-input-wrap">
                    <input type="text" id="vendedor" name="vendedor" placeholder="VENDEDOR" />
                    <span class="input-clear-button"></span>
                  </div>
                </div> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar vendedor">
                  <select name="vendedor" id="get-vendedores">        
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-vendedores-title">Vendedor</div>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <!-- <div class="item-content item-input">
                  <div class="item-input-wrap">
                    <input type="text" id="inspector" name="inspector" placeholder="INSPECTOR" />
                    <span class="input-clear-button"></span>
                  </div>
                </div> -->
                <a class="item-link smart-select smart-select-init" data-open-in="popup" data-searchbar="true" data-searchbar-placeholder="Buscar inspector">
                  <select name="inspector" id="get-inspectores">        
                  </select>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title" id="get-inspectores-title">Inspector</div>
                    </div>
                  </div>
                </a>
              </li>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-input-wrap">
                    <textarea placeholder="Comentarios" id="comentario" name="comentario" ></textarea>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </div>
  `
    }
    ;
}
framework7Component.id = '519506f06f';
export default framework7Component;